import { render, staticRenderFns } from "./AddPatientProvider.vue?vue&type=template&id=42b7c6c2&scoped=true&"
import script from "./AddPatientProvider.vue?vue&type=script&lang=js&"
export * from "./AddPatientProvider.vue?vue&type=script&lang=js&"
import style0 from "./AddPatientProvider.vue?vue&type=style&index=0&id=42b7c6c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b7c6c2",
  null
  
)

export default component.exports